/**
 * Converts an array of raw events into timeline segments using the actual
 * eventName and date from the API. Each segment runs from one event to the next.
 *
 * @param {Array<{eventName: string, date: string}>} events
 * @param {[number, number]} dateRange - [startMs, endMs]
 * @returns {Array<{label: string, start: number, end: number, durationMs: number}>}
 */
export function eventsToSegments(events, dateRange) {
  if (!events || events.length === 0) return [];

  const [, rangeEnd] = dateRange;

  // Sort oldest-first by date
  const sorted = [...events].map(e => ({ ...e, ts: new Date(e.date).getTime() })).sort((a, b) => a.ts - b.ts);

  const segments = [];

  sorted.forEach((ev, i) => {
    const start = ev.ts;
    const end = i < sorted.length - 1 ? sorted[i + 1].ts : rangeEnd;

    segments.push({
      label: ev.eventName,
      start,
      end: Math.max(end, start),
      durationMs: Math.max(end - start, 0),
    });
  });

  return segments;
}

/**
 * Formats a duration in ms to a human-readable string like "5h07m" or "2m".
 * @param {number} ms
 * @returns {string}
 */
export function formatDuration(ms) {
  const totalMin = Math.floor(ms / 60000);
  const hours = Math.floor(totalMin / 60);
  const mins = totalMin % 60;
  if (hours > 0) {
    return `${hours}h${String(mins).padStart(2, "0")}m`;
  }
  return `${mins}m`;
}
